// extracted by mini-css-extract-plugin
export var deleteIcon = "_tl-5";
export var deleteOption = "_tl-3";
export var divider = "_tl-2";
export var downloadIcon = "_tl-4";
export var drawer = "_tl-0";
export var drawerFooter = "_tl-6";
export var drawerOpen = "_tl-1";
export var highlighted = "_tl-7";
export var lighterHighlight = "_tl-8";